import ProductCoChart from './productCoChart';

export default ProductCoChart;
